import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { objectToSearch } from '../../helpers/query';
import { useSearchMainState } from '../../state';

const useSearchMainStateHelpers = () => {
  const state = useSearchMainState();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = useCallback(
    ({ target: { name, value } }) =>
      state.searchFilterState.setFilter(name, value),
    [state]
  );

  const handleLocationChange = useCallback(
    ({ target: { value } }) =>
      state.searchFilterState.setFilter('location', value),
    [state]
  );

  const handleReset = useCallback(() => {
    // state.setFilterIsOpen(false);
    const currentSearch = location.search;
    const newSearch = '';
    if (newSearch !== currentSearch) {
      console.log('PUSHING');
      navigate(`${location.pathname}${newSearch}`);
      state.searchFilterState.resetFilter();
    }
  }, [navigate, location.search, location.pathname, state.searchFilterState]);

  const handleSubmit = useCallback(
    (e) => {
      e?.preventDefault();
      state.setFilterIsOpen(false);
      const currentSearch = location.search;
      const newSearch = objectToSearch(state.searchFilterState.state, true);
      console.log(currentSearch, newSearch);
      if (newSearch !== currentSearch) {
        console.log('PUSHING');
        navigate(`${location.pathname}${newSearch}`);
      }
    },
    [state, navigate, location.search, location.pathname]
  );

  const handleSubmitWithLocation = useCallback(
    (newLocation) => {
      const currentSearch = location.search;
      const newBrowserState = { ...state.searchBrowserFilterState.state };
      newBrowserState.location = newLocation;
      const newSearch = objectToSearch(newBrowserState, true);
      if (newSearch !== currentSearch) {
        console.log('PUSHING');
        navigate(`${location.pathname}${newSearch}`);
      }
    },
    [
      state.searchBrowserFilterState.state,
      location.search,
      location.pathname,
      navigate,
    ]
  );

  return {
    state,
    handleChange,
    handleLocationChange,
    handleSubmit,
    handleSubmitWithLocation,
    handleReset,
  };
};

export default useSearchMainStateHelpers;
